import { useEffect } from "react"
import { connect } from "react-redux"
import BVAInput from "../../../../components/BVAInput/BVAInput";
import CurrencyFormatter from "currency-formatter";
import {
  addCustomFieldToPurchaseAcquisitionExpenses,
  generatePurchaserAcquisitionExpenses,
  updateCustomFieldOnProceedsWorksheet,
  updatePurchaserAcquisitionExpenses,
} from "../../../../store/modules/acquisitionExpenses/actions";
import BVAButton from "../../../../components/BVAButton/BVAButton";
import DeleteIcon from "@mui/icons-material/Delete";


const addItemContainerWidth = "calc(784px - 48px - 1rem)";


function AssetPurchaserAcquisitionExpenses({
  assetPurchaserAcquisitionExpenses,
  dispatchUpdatePurchaserAcquisitionExpenses,
  dispatchGeneratePurchaserAcquisitionExpenses,
  dispatchAddCustomFieldToAssetPurchaseAcquisitionExpenses,
  dispatchUpdateCustomFieldOnAssetPurchaseAcquisitionExpenses
}) {
  // Mounted
  useEffect(() => {
    dispatchGeneratePurchaserAcquisitionExpenses()
  }, [])

  // Methods
  const handleAssetPurchaserAcquisitionExpensesOnChange = (groupKey, key, value) => {
    dispatchUpdatePurchaserAcquisitionExpenses({
      [groupKey]: {
        [key]: CurrencyFormatter.unformat(value, { code: "USD" })
      }
    })
  }

  const handleCustomFieldOnCreation = (section) => {
    dispatchAddCustomFieldToAssetPurchaseAcquisitionExpenses({ section })
  }

  const handleCustomFieldValueOnUpdate = ({ section, index, name, value }) => {
    const customFields = assetPurchaserAcquisitionExpenses[section].customFields.map((customField, _index) => {
      if (_index === index) {
        const _customField = { ...customField }
        if (name || name === "") _customField.name = name
        if (value || value === 0 || value === "") _customField.value = CurrencyFormatter.unformat(value, { code: "USD" })

        return _customField
      }

      return customField
    })

    dispatchUpdateCustomFieldOnAssetPurchaseAcquisitionExpenses({ section, customFields })
  }

  const handleDeleteCustomField = ({ section, index }) => {
    const customFields = assetPurchaserAcquisitionExpenses[section].customFields.filter((customField, _index) => {
      if (_index === index) return false

      return true
    })

    dispatchUpdateCustomFieldOnAssetPurchaseAcquisitionExpenses({ section, customFields })
  }

  return (
    <div>
      <div className="mt-10">
        <h2 className="text-lg font-semibold">Due Diligence and Transaction Expenses</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">
                Attorney Fees
              </label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.attorneyFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "attorneyFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Escrow Service Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.escrowServiceFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "escrowServiceFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Appraisal Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.appraisalFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "appraisalFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Accountant's Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.accountantsFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "accountantsFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Franchise License Agreement Transfer Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.franchiseLicenseAgreementTransferFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "franchiseLicenseAgreementTransferFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Business Brokerage Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.businessBrokerageFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "businessBrokerageFees", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Filings & Recording Fees</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.generalAcquisition?.fillingsRecordingFees}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("generalAcquisition", "fillingsRecordingFees", value)}/>
            </div>
          </div>
          {assetPurchaserAcquisitionExpenses?.generalAcquisition?.customFields?.map((customField, index) => (
            <div key={index} className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "generalAcquisition",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "generalAcquisition",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "generalAcquisition", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("generalAcquisition")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Closing Costs to Be Paid by Purchaser
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {assetPurchaserAcquisitionExpenses?.generalAcquisition?.totalClosingCostsToBePaidByPurchaserFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-lg font-semibold">General Business Expenses</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Franchisor Training Expenses</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.franchisorTrainingExpenses}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "franchisorTrainingExpenses", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">City, County & State Business Licenses and Permits</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.cityCountyAndStateBusinessLicensesAndPermits}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "cityCountyAndStateBusinessLicensesAndPermits", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Loan Fees for 3rd Party Purchase Loan</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.loanFeesForThirdPartyPurchaseLoan}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "loanFeesForThirdPartyPurchaseLoan", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Travel Expenses</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.travelExpenses}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("acquisitionLicensesTaxesPermitsAndFees", "travelExpenses", value)}/>
            </div>
          </div>

          {assetPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.customFields?.map((customField, index) => (
            <div key={index} className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "acquisitionLicensesTaxesPermitsAndFees",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "acquisitionLicensesTaxesPermitsAndFees",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "acquisitionLicensesTaxesPermitsAndFees", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("acquisitionLicensesTaxesPermitsAndFees")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Closing Costs to Be Paid by Purchaser
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {assetPurchaserAcquisitionExpenses?.acquisitionLicensesTaxesPermitsAndFees?.totalAdditionalPurchaserCashPayoutRequirementsFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-lg font-semibold">(Pre-Paid) Assets Needed</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">
                Lease Deposit
              </label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.leaseDeposit}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "leaseDeposit", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Utility Company Deposit</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.utilityCompanyDeposit}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "utilityCompanyDeposit", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Product Liability & Comprehensive Insurance Prepayment</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.productLiabilityAndComprehensiveInsurancePrepayment}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "productLiabilityAndComprehensiveInsurancePrepayment", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Workers Compensation Insurance Prepayment</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.workersCompensationInsurancePrepayment}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("prePaidAssetsNeeded", "workersCompensationInsurancePrepayment", value)}/>
            </div>
          </div>

          {assetPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.customFields?.map((customField, index) => (
            <div key={index} className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "prePaidAssetsNeeded",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "prePaidAssetsNeeded",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "prePaidAssetsNeeded", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("prePaidAssetsNeeded")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Closing Costs to Be Paid by Purchaser
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {assetPurchaserAcquisitionExpenses?.prePaidAssetsNeeded?.totalAdditionalPurchaserCashPayoutForAssetsFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <h2 className="text-lg font-semibold">Working Capital Needed at Closing</h2>
        <div className="mt-4">
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Operating Cash</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.operatingCash}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("workingCapitalNeededAtClosing", "operatingCash", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Accounts Receivable</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.accountsReceivable}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("workingCapitalNeededAtClosing", "accountsReceivable", value)}/>
            </div>
          </div>
          <div className="flex mb-2 items-center">
            <div className="w-96 flex items-center pr-2">
              <label className="whitespace-nowrap text-center">Inventory</label>
            </div>
            <div className="w-40 flex items-center pr-2" />
            <div className="w-60 flex items-center pr-10 -ml-5">
              <BVAInput
                size="small"
                startAdornment
                startAdornmentLabel="$"
                value={assetPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.inventory}
                onChange={(value) => handleAssetPurchaserAcquisitionExpensesOnChange("workingCapitalNeededAtClosing", "inventory", value)}/>
            </div>
          </div>

          {assetPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.customFields?.map((customField, index) => (
            <div key={index} className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <BVAInput
                  value={customField?.name}
                  placeholder="Item name"
                  type="text"
                  size="small"
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "workingCapitalNeededAtClosing",
                    index,
                    name: value
                  })}/>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="flex items-center -ml-5">
                <BVAInput
                  size="small"
                  startAdornment
                  startAdornmentLabel="$"
                  value={customField?.value}
                  onChange={(value) => handleCustomFieldValueOnUpdate({
                    section: "workingCapitalNeededAtClosing",
                    index,
                    value
                  })} />
                <div className="ml-2">
                  <BVAButton
                    shape="circle"
                    iconButton
                    icon={{ url: DeleteIcon }}
                    onClick={() => handleDeleteCustomField({ section: "workingCapitalNeededAtClosing", index })} />
                </div>
              </div>
            </div>
          ))}
          <div className="mt-10 flex justify-center border rounded p-5" style={{ maxWidth: addItemContainerWidth }}>
            <BVAButton
              kind="primary-outlined"
              slimHeight
              onClick={() => handleCustomFieldOnCreation("workingCapitalNeededAtClosing")}>
              Add Item
            </BVAButton>
          </div>

          <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4" style={{ maxWidth: addItemContainerWidth }}>
            <div className="w-96 flex justify-center flex-col pr-2">
              <label className="whitespace-nowrap font-semibold">
                Total Cash Payment for All Additional Assets to Be Purchased
              </label>
            </div>
            <div className="w-60 flex items-center pr-2 -ml-10" />
            <div className="flex items-center pr-10">
              <label className="whitespace-nowrap">
                {assetPurchaserAcquisitionExpenses?.workingCapitalNeededAtClosing?.totalCashPaymentForAllAdditionalAssetsToBePurchasedFormatted}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <div className="flex items-center mb-4 bg-neutral-200 p-5 rounded-lg" style={{ maxWidth: addItemContainerWidth }}>
          <div className="w-96 flex items-center pr-2">
            <label className="whitespace-nowrap font-semibold">Additional Capital Needed at Closing</label>
          </div>
          <div className="w-60 flex items-center pr-2" />

          <div className="flex items-center pr-10 -ml-10">
            <label className="whitespace-nowrap font-semibold">
              {assetPurchaserAcquisitionExpenses?.additionalCapitalNeededAtClosingFormatted}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  assetPurchaserAcquisitionExpenses: state.acquisitionExpenses.assetPurchaserAcquisitionExpenses
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGeneratePurchaserAcquisitionExpenses() {
    dispatch(generatePurchaserAcquisitionExpenses({
      purchaseAcquisitionExpensesType: "asset"
    }))
  },

  dispatchUpdatePurchaserAcquisitionExpenses({
    generalAcquisition,
    acquisitionLicensesTaxesPermitsAndFees,
    prePaidAssetsNeeded,
    workingCapitalNeededAtClosing
  }) {
    dispatch(updatePurchaserAcquisitionExpenses({
      purchaserAcquisitionExpensesType: "asset"
    }, {
      generalAcquisition,
      acquisitionLicensesTaxesPermitsAndFees,
      prePaidAssetsNeeded,
      workingCapitalNeededAtClosing
    }))
  },

  dispatchAddCustomFieldToAssetPurchaseAcquisitionExpenses({ section }) {
    dispatch(addCustomFieldToPurchaseAcquisitionExpenses({
      purchaserAcquisitionExpensesType: "asset"
    }, {
      section
    }))
  },

  dispatchUpdateCustomFieldOnAssetPurchaseAcquisitionExpenses({ customFields, section }) {
    dispatch(updateCustomFieldOnProceedsWorksheet({
      purchaserAcquisitionExpensesType: "asset"
    }, {
      section,
      customFields
    }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AssetPurchaserAcquisitionExpenses)